import { useNavigate, useSearchParams } from 'react-router-dom';
import RegistrationBackground from 'components/RegistrationBackground';
import { FeedbackPanel } from 'components/FeedbackModal';

export default function RegistrationWelcomePage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const email = searchParams.get('email') || '';
    const phoneNumber = searchParams.get('phoneNumber') || '';

    const actions = (
        <button
            type="button"
            onClick={() =>
                navigate(`/regisztracio-megerosites?email=${encodeURIComponent(email)}&phoneNumber=${encodeURIComponent(phoneNumber)}`)
            }
            className="form-action-button form-action-primary flex-1"
        >
            Tovább a megerősítéshez
        </button>
    );

    return (
        <RegistrationBackground>
            <FeedbackPanel
                tone="success"
                title="Köszi, hogy regisztráltál!"
                message={<>A megerősítő kódot erre a telefonszámra küldjük: <strong>+36 {phoneNumber}</strong></>}
                actions={actions}
            >
                <div className="mt-5 rounded-xl border border-green-100 bg-green-50 p-4 text-sm font-semibold leading-relaxed text-green-900">
                    Legfeljebb 2 percen belül ingyenes SMS-t küldünk a személyre szóló, hatjegyű regisztrációs kódoddal.
                </div>
            </FeedbackPanel>
        </RegistrationBackground>
    );
}
